import {
  FetchError,
  ProblemDetailError,
  ApiError as SdkApiError
} from "@wingspanhq/wingspan-api-sdk";

export type ApiError = SdkApiError;

export const isApiError = (error: unknown): error is ApiError =>
  error instanceof SdkApiError;

export const isNetworkError = (error: unknown): boolean =>
  error instanceof FetchError ||
  (error instanceof Error &&
    (error.name === "FetchError" || error.message === "Network Error"));

/** HTTP status of a failed call — SDK errors first, legacy axios shape as fallback. */
export const getApiErrorStatus = (error: unknown): number | undefined => {
  if (isApiError(error)) {
    return error.status;
  }
  return (error as any)?.response?.status;
};

/** Human-readable message of a failed call, per RFC 9457 precedence. */
export const getApiErrorMessage = (error: unknown): string | undefined => {
  if (error instanceof ProblemDetailError) {
    return error.detail || error.title || error.response.statusText;
  }
  if (isApiError(error)) {
    return error.response.statusText;
  }
  return undefined;
};
